import Styles from "./index.module.scss";
import CXS    from "classnames";

export const CX = CXS.bind( Styles );
export { Styles };
export default CX;